const style1 = {
    backgroundColor: "#fff",
    display: "inline-block",
    fontFamily:"Roboto,sans-serif",
    color: "#a7a7a7",
    fontSize: "11px",
    width:" 100%",
    maxWidth:"339px"
}
const style2 = {
    padding:"0",
    margin: "0",
    textAlign: "left"
}
const style3 = {
    color:"#a7a7a7",
    textDecoration: "none",
    fontWeight: "normal",
    border: "none",
    display: "inline-block"
}
const style4 = {
    overflow: "hidden",
    position:"relative",
    height:"0",
    padding:"149.26254% 0 0 0",
    width:"100%"
}
const style5 = {
    display:"inline-block",
    position:"absolute",
    top:"0",
    left:"0",
    width:"100%",
    height:"100%",
    margin:"0"
}
function DeclarationAltEmbed(){
    return (
        <>
        <div class="getty embed image" style={style1}><div style={style2}><a href="https://www.gettyimages.com/detail/173247597" target="_blank" rel="noreferrer" style={style3}>Embed from Getty Images</a></div><div style={style4}><iframe src="//embed.gettyimages.com/embed/173247597?et=S4ZFkxqxRThCTjTR9SiXpQ&tld=com&sig=gMLhYe80u1cAuQ1guXLzqEVLZZ00iy64OIqH8gJ0wm0=&caption=true&ver=1" title="Declaration and Constitution" scrolling="no" frameBorder="0" width="339" height="506" style={style5}></iframe></div></div>
        </>
    );
};
export default DeclarationAltEmbed;